import styled from "styled-components"
import Title from "./Title"
import { device } from "../styles/stylesConfig"
import { memo, useContext, useEffect } from "react"
import { useLocation } from "react-router-dom"
import { allAnimations } from "../effects/Observers"
import { ThemeContext } from "../contexts/theme/ThemeContext"
import { useTranslation } from "react-i18next"

const Container = styled.div`
    width: 100%;
    padding-top: 10vh;
    padding-bottom: 10vh;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    position: relative;
    overflow: hidden;
    z-index: 2;
`

const ContentContainer = styled.div`
    width: 70%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    z-index: 1;

    @media ${device.lg} {
        width: 100%;

        & > div > h1 {
            text-align: center !important;
        }

    }

    p {
        width: 90%;
        color: #2E2D2D;
        line-height: 28px;
        font-size: 14px;

        @media ${device.lg} {
            /* width: 65%; */
            width: 85%;
        }

        @media ${device.md} {
            width: 85%;
        }

        @media ${device.sm} {
            font-size: 12px;
            line-height: 24px;
            width: 90%;
        }
    }
    
`

interface Props {
    title: string;
    subtitles: string[];
}

const PrivacySectionComponent = ({ title, subtitles }: Props) => {

    const location = useLocation()

    const {
        theme,
    } = useContext(ThemeContext);

    const { i18n } = useTranslation();

    useEffect(() => {

        allAnimations();

        return () => { allAnimations() };

    }, [location.pathname, i18n.language, theme])


    return (

        <Container>

            <ContentContainer>

                <Title
                    title={title}
                    titleColor="#004bb5"
                    textAlign="start"
                    titleLighter
                />

                {subtitles.map((v) => (<p key={v} className="utils__fade-in-fast-top" dangerouslySetInnerHTML={{ __html: v }} />))}

            </ContentContainer>


        </Container>

    )
}

const PrivacySection = memo(PrivacySectionComponent);

export default PrivacySection;